<template>
    <div style="height: 100%;">
        <div class="action-header">
            <div class="btn-new" v-if="lastLevel.level === 2">
                <el-upload
                    :before-upload="upload"
                    :limit="1"
                    :show-file-list="false"
                    action="//"
                    ref="file"
                >
                    <el-button icon="el-icon-upload" type="primary">上传文件</el-button>
                </el-upload>
            </div>
            <el-button
                @click="clickCreate"
                class="btn-new"
                icon="el-icon-plus"
                type="primary"
                v-else
            >新建分类</el-button>
            <el-button-group class="btn-group" v-if="selection.length > 0">
                <el-button
                    @click="clickDelete"
                    icon="el-icon-delete"
                    v-if="lastLevel.level === 2"
                >删除</el-button>
                <el-button @click="clickRename" v-if="selection.length === 1">重命名</el-button>
                <el-button @click="clickMove" v-if="lastLevel.level === 2">移动到</el-button>
                <el-button @click="clickCopy" v-if="lastLevel.level === 2">复制到</el-button>
            </el-button-group>
            <!-- <el-input class='input' placeholder='搜索您的素材'>
                <i
                    @click='handleSearchFiles'
                    class='el-input__icon el-icon-search btn-search'
                    slot='suffix'
                />
            </el-input>-->
        </div>
        <Breadcrumb />
        <Talbe />
        <DialogLabel />
        <DialogFile />
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { FILE_MOVE, FILE_COPY } from '../../libs/enum.js';
import Breadcrumb from './breadcrumb';
import Talbe from './table';
import DialogLabel from './dialog.label';
import DialogFile from './dialog.file';

const { mapState, mapGetters, mapActions } = createNamespacedHelpers(
    'resource'
);

export default {
    components: { Breadcrumb, Talbe, DialogLabel, DialogFile },
    computed: {
        ...mapState({
            path: (state) => state.path,
            search: (state) => state.search,
            selection: (state) => state.selection,
        }),
        ...mapGetters(['lastLevel']),
    },
    methods: {
        ...mapActions([
            'changeLabelDialog',
            'getLabelList',
            'deleteFiles',
            'deleteLabels',
            'uploadFile',
            'changeCanRename',
            'changeFileDialog',
            'resetState',
        ]),
        upload(file) {
            this.$refs.file.clearFiles();

            this.uploadFile(file);
        },
        clickCreate() {
            this.changeLabelDialog({ visible: true });
        },
        clickDelete() {
            if (this.lastLevel.level === 2) {
                const labelFileIds = this.selection
                    .map((item) => item.labelFileId)
                    .join(',');
                this.deleteFiles({ labelFileIds });
            } else {
                const labelIds = this.selection
                    .map((item) => item.labelId)
                    .join(',');
                this.deleteLabels({ labelIds });
            }
        },
        clickRename() {
            const label = this.selection[0];
            this.changeCanRename({
                show: true,
                name: label.level ? label.labelName : label.fileName,
            });
        },
        clickMove() {
            this.changeFileDialog({ visible: true, type: FILE_MOVE });
        },
        clickCopy() {
            this.changeFileDialog({ visible: true, type: FILE_COPY });
        },
    },
    mounted() {
        this.getLabelList({ ...this.search, labelId: 0 });
    },
    beforeDestroy() {
        this.resetState();
    },
};
</script>

<style lang="less" scoped>
.action-header {
    margin-bottom: 10px;
    .btn-new {
        margin-right: 20px;
    }
    .btn-new,
    .btn-group {
        display: inline-block;
        vertical-align: top;
    }
    .input {
        float: right;
        width: 250px;
    }
}
.btn-search {
    width: 30px;
    font-size: 18px;
    cursor: pointer;
    &:hover {
        color: #409eff;
    }
}
</style>
